import { render } from "./PrivateAddressAdditionForm.vue?vue&type=template&id=ef644eea&ts=true"
import script from "./PrivateAddressAdditionForm.vue?vue&type=script&lang=ts"
export * from "./PrivateAddressAdditionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__